<template>
  <div v-if="ambition?.title">
    <SplitContainerAmbition
      class="overflow-hidden"
      :ambition="parentAmbition"
    >
      <template #head>
        <div class="pb-10 lg:pb-20">
          <NuxtLink
            class="link-back-to mb-10 lg:mb-20"
            :to="localePath({name: 'ambitions-ambition', params: {ambition: parentAmbition?.slug}})"
          >
            {{ $t('Back to') }} {{ parentAmbition?.title }}
          </NuxtLink>
          <AmbitionMessagesSelect
            :active-ambition="ambition"
            :color="parentAmbition?.color"
            :ambitions="parentAmbition?.children ?? []"
            class="mb-7 !overflow-visible lg:mb-10"
          />
          <div class="grid-reversed max-xl:grid-content-wider grid-side-content">
            <div>
              <div class="heading text-white lg:pb-2.5">
                {{ ambition.title }}
              </div>
              <SofieText
                class="prose prose-invert !text-white"
                :class="ambition.slug || parentAmbition?.slug === 'markt-en-economie' ? 'prose-a:text-purple' : ''"
                :value="ambition.text"
              />
            </div>
            <div v-if="ambition.downloads?.length">
              <DownloadsCard
                class="max-lg:mt-10 max-lg:max-w-md"
                :downloads="ambition.downloads"
              />
            </div>
          </div>
        </div>
      </template>
    </SplitContainerAmbition>

    <section class="container py-10 lg:py-20">
      <hero>
        <template #default>
          <SofieText
            class="hero-title green-question-suffix"
            :value="heroTitle"
          />
          <SofieText
            class="max-lg:hidden lg:pt-2.5 lg:text-white"
            :value="heroDesc"
          />
        </template>
      </hero>
      <div class="flex -translate-y-6 flex-col items-center">
        <Btn
          class="!mt-0"
          :to="localePath({name: 'about-us', hash: `#${$t('Vacancies').toLowerCase()}`})"
          :label="$t('Go to our vacancies')"
          :short-label="$t('Our vacancies')"
          centered
        />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {AmbitionDocument, type AmbitionQuery} from '~/graphql/graphql';

const route = useRoute();
const localePath = useLocalePath();

const {data: parentAmbitionData} = await useAsyncQuery<AmbitionQuery>(AmbitionDocument, {
  slug: route.params.ambition,
});

if (!parentAmbitionData.value?.ambition) {
  throw createError({statusCode: 404});
}
const parentAmbition = computed(() => parentAmbitionData.value.ambition!);

const {data: ambitionData} = await useAsyncQuery<AmbitionQuery>(AmbitionDocument, {
  slug: route.params.slug,
});

if (!ambitionData.value?.ambition) {
  throw createError({statusCode: 404});
}
const ambition = computed(() => ambitionData.value.ambition!);

const heroTitle = '<p>Heb jij hart voor een<br>gezonde generatie</p>';
const heroDesc = '<p>Door middel van onze<br>ambities werken we toe naar<br>een gezonde generatie.</p>';
</script>
